import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";

import { AppConfigService } from "../../providers/config.service";
import { FranchiseAppGlobal } from "src/app/franchise-app-global";
import { TranslateService } from "@ngx-translate/core";
import { saveAs } from "file-saver";

export class Extension {
  Id: number;
  Name: string;
  Size?: string;
}

export enum ErrorCode {
  ExeededNoOfFiles,
  FailedToGetUploadedFiles,
  FailedToDeleteFile,
  FailedToUploadFiles,
  FileDeletedSuccessfully,
}

export class OperationResult {
  ID?: ErrorCode;
  Message?: string;
}

export interface fileMetadata {
  publicId?: number;
  fileName?: string;
  fileType?: string;
}

export enum FileUploaderAction {
  Upload = 1,
  Delete = 2,
}

export interface AttachmentContent {
  content?: string;
}

@Component({
  selector: "file-upload",
  templateUrl: "./file-upload.component.html",
  styleUrls: ["./file-upload.component.css"],
  outputs: ["onAttachment", "onSuccess", "onError"],
})
export class FileUploadComponent implements OnInit, OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
    if (this.objectId && this.attachmentTypeId && this.attachmentTypeId) {
      this.configureValidations();
      this.getAttachments();
    }
  }

  // Validation
  formGroup: FormGroup = new FormGroup({
    fileUpload: new FormControl("", [Validators.required]),
  });

  @ViewChild("fileUpload")
  fileUpload: any;
  public selectedFiles: FileList;
  // Outputs
  public onAttachment = new EventEmitter();
  public onSuccess = new EventEmitter();
  public onError = new EventEmitter();

  // Inputs
  @Input() objectId: number;
  @Input() objectTypeId: number;
  @Input() attachmentTypeId: number;
  @Input() label: string;
  @Input() isRequired: boolean = false;
  @Input() isAddToDb: boolean = true;
  @Input() noOfFiles: number = 1;
  @Input() extensions: Array<Extension> = [{ Id: 1, Name: "pdf", Size: "10MB" }];
  @Input() requiredMsg: string = "Global.AttachmentFileRequired";
  @Input() isAdmin: boolean = false;
  harmFulExtensions = [
    "exe",
    "com",
    "bat",
    "cmd",
    "msi",
    "vb",
    "vbs",
    "ws",
    "wsf",
    "scf",
    "scr",
    "pif",
  ];
  // Model.
  public uploadedFiles: number = 0;
  public isValidFileExtension: boolean;
  public isHarmFulExtension: boolean;
  public isValidFileSize: boolean;
  public isValidFileName: boolean;

  public files: Array<fileMetadata> = [];
  public localFileNames = new Array<string>();

  // Variables.
  public acceptedExtensions: string = ".pdf";
  public operaitonResult: OperationResult;
  public displayUploadedFileUrl: string | null = null;
  public previewFileUrl: string | null = null;
  public extenstionsLabel: string = "";
  public fileSize: number = 0;
  public isAttachFromDb: boolean = false;

  // No of uploading file is 1 by default.
  private env;

  constructor(
    public http: HttpClient,
    public translateService: TranslateService,
    private config: AppConfigService
  ) {
    this.env = this.config.getConfig();
    this.displayUploadedFileUrl = `${this.env.baseUrl}${
      this.isAdmin
        ? FranchiseAppGlobal.displayAdminUploadedFileUrl
        : FranchiseAppGlobal.displayUploadedFileUrl
    }`;

    this.previewFileUrl = `${this.env.baseUrl}${
      this.isAdmin
        ? FranchiseAppGlobal.previewAdminFileUrl
        : FranchiseAppGlobal.previewFileUrl
    }`;
  }

  ngOnInit() {
    this.isValidFileExtension = true;
    this.isValidFileSize = true;
    this.isValidFileName = true;
    this.isHarmFulExtension = false;
    if (this.extensions) {
      this.acceptedExtensions = this.extensions
        .map((item) => {
          return `.${item.Name}`;
        })
        .join(", ");
    }
  }

  isValidExtension(fileName: string): boolean {
    //
    let fileExtension = fileName.slice(
      ((fileName.lastIndexOf(".") - 1) >>> 0) + 2
    );

    for (let i = 0; i < this.extensions.length; i++) {
      if (
        fileExtension.toUpperCase() === this.extensions[i].Name.toUpperCase()
      ) {
        return true;
      }
    }

    return false;
  }
  isHarmfulExtension(fileName: string): boolean {
    let fileExtension = fileName.slice(
      ((fileName.lastIndexOf(".") - 1) >>> 0) + 2
    );
    if (
      this.harmFulExtensions.some(
        (ext) => ext.toUpperCase() === fileExtension.toUpperCase()
      )
    ) {
      return true;
    }
    return false;
  }

  isValidLength(fileName: string): boolean {
    if (fileName.length) {
      this.isValidFileName = fileName.length < 50;
      return fileName.length < 50;
    } else return true;
  }

  getAttachments(): any {
    let params = new HttpParams()
      .set("objectId", this.objectId.toString())
      .set("attachmentTypeId", this.attachmentTypeId.toString())
      .set("objectTypeId", this.objectTypeId.toString());
    var observable = this.http.get(
      `${this.env.baseUrl}${
        this.isAdmin
          ? FranchiseAppGlobal.fileAdminAttachmentGet
          : FranchiseAppGlobal.fileAttachmentGet
      }`,
      {
        params: params,
      }
    );
    //this.showLoader()

    observable.subscribe(
      (res) => this.getAttachmentsSuccess(res),
      (res) => this.getAttachmentsError(res)
    );
  }

  getAttachmentsSuccess(res: any) {
    if (res && res.length > 0) {
      //
      this.isAttachFromDb = true;
      //this.hideLoader()
      this.files = res;

      for (let i = 0; i < res.length; i++) {
        this.fileSize = res[i].Size / 1024 / 1024;
      }
      this.uploadedFiles = this.files.length;
    } else {
      this.uploadedFiles = 0;
      this.files = [];
    }
    this.attachmentEvent(this.files);
  }

  getAttachmentsError(res: any) {
    //this.hideLoader()

    let message: string | undefined;

    this.translateService
      .get("Global.FileUpload.GetFilesError")
      .subscribe((t) => {
        message = t;
      });

    this.operaitonResult = {
      ID: ErrorCode.FailedToGetUploadedFiles,
      Message: message,
    };

    this.attachmentEvent(this.files);
    this.errorEvent(this.operaitonResult);
  }

  isFormValid(): boolean {
    this.clearValidations();
    let isValid = true;
    this.formGroup.reset();
    if (this.isRequired) {
      if (this.isAddToDb && this.uploadedFiles == 0) {
        isValid = false;
      } else if (
        (!this.isAddToDb && this.fileUpload.nativeElement.files.length <= 0) ||
        (this.localFileNames.length <= 0 && this.files.length <= 0)
      ) {
        isValid = false;
      }
    }

    if (!isValid) {
      for (let control in this.formGroup.controls) {
        this.formGroup.controls[control].markAsTouched();
      }
    }

    return isValid;
  }

  configureValidations() {
    this.isRequired
      ? this.formGroup.controls["fileUpload"].enable()
      : this.formGroup.controls["fileUpload"].disable();
  }

  // Ensure that all the inputs were passed
  checkInputs() {
    if (
      !this.attachmentTypeId ||
      !this.objectId ||
      !this.label ||
      !this.extensions ||
      (this.extensions && this.extensions.length == 0)
    ) {
      throw new Error(
        `Not all inputs were passed - attachmentTypeId: ${this.attachmentTypeId} objectId: ${this.objectId} label: ${this.label} extensions: ${this.extensions}`
      );
    }
  }

  postFile(files: FileList) {
    //
    if (this.isAddToDb) {
      this.sendFileToDb(files);
    } else {
      this.handleLocalFile(files);
    }
  }

  handleLocalFile(files: FileList) {
    if (files.length <= 0) {
      this.uploadedFiles = 0;
      this.localFileNames = [];
      this.fileUpload.nativeElement.value = "";
    } else {
      if (files.length == 1 && this.noOfFiles == 1) {
        this.localFileNames = [];
        this.uploadedFiles = 0;
        if (this.isValidFiles(files)) {
          for (let i = 0; i < files.length; i++) {
            this.localFileNames.push(files[i].name);
          }
          this.uploadedFiles = this.localFileNames.length;
          this.selectedFiles = files;
        }
      } else if (files.length <= this.noOfFiles && this.noOfFiles > 1) {
        this.localFileNames = [];
        this.uploadedFiles = 0;

        if (this.isValidFiles(files)) {
          for (let i = 0; i < files.length; i++) {
            this.localFileNames.push(files[i].name);
          }
          this.uploadedFiles = this.localFileNames.length;
          this.selectedFiles = files;
        } else {
          this.fileUpload.nativeElement.value = "";
        }
      } else {
        let message = this.translateService.instant(
          "Global.FileUpload.MaxFilesExceeded"
        );
        this.operaitonResult = {
          ID: ErrorCode.ExeededNoOfFiles,
          Message: message,
        };
        this.errorEvent(this.operaitonResult);
        this.fileUpload.nativeElement.value = "";
        this.uploadedFiles = 0;
        this.localFileNames = [];
      }
    }
  }

  sendFileToDb(files: FileList) {
    //
    if (this.uploadedFiles + files.length <= this.noOfFiles) {
      this.resetValidations();
      if (this.isValidFiles(files)) {
        let formData: FormData = new FormData();
        let fileNames = new Array<string>();
        let fileNamesObj = {};

        for (let i = 0; i < files.length; i++) {
          formData.append("file", files[i]);
          fileNames.push(files[i].name);

          let attachmentExtension = this.getAttachmentExtension(files[i].name);
          formData.append("attachmentTypeId", this.attachmentTypeId.toString());
          formData.append(
            "attachmentExtension",
            attachmentExtension.toString()
          );
          formData.append("objectId", this.objectId.toString());
          formData.append("objectTypeId", this.objectTypeId.toString());
          let uri = `${this.env.baseUrl}${
            this.isAdmin
              ? FranchiseAppGlobal.fileAdminUploadUrl
              : FranchiseAppGlobal.fileUploadUrl
          }`;

          var observable = this.http.post(uri, formData);
          //this.showLoader()
          observable.subscribe(
            (res) => {
              //this.hideLoader()

              this.postFileSuccess(res);
            },
            (error) => {
              //this.hideLoader()

              this.postFileError(error);
            }
          );
        }
      }
    } else {
      //
      this.fileUpload.nativeElement.value = "";
      let message = "امتداد الملف غير صحيح";

      this.operaitonResult = {
        ID: ErrorCode.ExeededNoOfFiles,
        Message: message,
      };

      this.errorEvent(this.operaitonResult);
    }
  }

  postFileSuccess(res: any) {
    let message = this.translateService.instant("Global.UploadSuccess");
    this.uploadSuccessEvent(
      this.objectId,
      this.objectTypeId,
      this.attachmentTypeId,
      res,
      message
    );
  }

  postFileError(res: any) {
    // console.log("error_message: ", res);

    this.formGroup.controls["fileUpload"].setValue("");
    this.fileUpload.nativeElement.value = "";
    this.files = [];

    let message = this.translateService.instant(
      "Global.FileUpload.PostFileError"
    );

    this.operaitonResult = {
      ID: ErrorCode.FailedToUploadFiles,
      Message: message,
    };

    this.errorEvent(this.operaitonResult);
  }

  getAttachmentExtension(fileName: any): string {
    let fileExtension = fileName.slice(
      ((fileName.lastIndexOf(".") - 1) >>> 0) + 2
    );
    let Id = "";
    for (let i = 0; i < this.extensions.length; i++) {
      if (
        this.extensions[i].Name.toLowerCase() == fileExtension.toLowerCase()
      ) {
        Id = this.extensions[i].Name;
      }
    }

    return Id;
  }

  public isValidFiles(files: FileList): boolean {
    for (let i = 0; i < files.length; i++) {
      this.isValidFileExtension = this.isValidExtension(files[i].name);
      this.isHarmFulExtension = this.isHarmfulExtension(files[i].name);
      this.isValidFileName = this.isValidLength(files[i].name);

      let fileSize = files[i].size / 1024 / 1024;
      this.isValidFileSize = fileSize <= 10 && fileSize > 0;
      if (!this.isAttachFromDb) this.fileSize = fileSize;
      if (
        this.isHarmFulExtension ||
        !this.isValidFileExtension ||
        !this.isValidFileSize ||
        !this.isValidFileName
      ) {
        return false;
      }
    }
    this.resetValidations();
    return true;
  }

  public errorEvent(res: any) {
    this.onError.emit({
      value: res,
    });
  }

  public attachmentEvent(res: any) {
    this.onAttachment.emit(res);
  }
  public uploadSuccessEvent(
    objectId: any,
    objectTypeId: any,
    attachementTypeId: any,
    publicId: any,
    res: any
  ) {
    this.getAttachments();
    this.resetValidations();
    this.onSuccess.emit({
      objectId: objectId,
      objectTypeId: objectTypeId,
      attachementTypeId: attachementTypeId,
      publicId: publicId,
      action: FileUploaderAction.Upload,
      value: res,
    });
  }

  public deleteSuccessEvent(
    objectId: any,
    objectTypeId: any,
    attachementTypeId: any,
    res: any
  ) {
    this.getAttachments();
    this.resetValidations();
    this.onSuccess.emit({
      objectId: objectId,
      objectTypeId: objectTypeId,
      attachementTypeId: attachementTypeId,
      action: FileUploaderAction.Delete,
      value: res,
    });
  }

  resetValidations() {
    this.isValidFileExtension = true;
    this.isValidFileSize = true;
    this.isValidFileName = true;
    this.isHarmFulExtension = false;
    this.formGroup.reset();
  }

  deleteLocalFiles() {
    this.fileUpload.nativeElement.value = "";

    if (!this.isAddToDb) {
      this.localFileNames = [];
    }

    if (this.uploadedFiles > 0) {
      this.uploadedFiles = 0;
    }
  }

  deleteFile(fileID: any) {
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      //body: JSON.stringify(fileID),
    };

    let url = `${this.env.baseUrl}${
      this.isAdmin
        ? FranchiseAppGlobal.deleteAdminFileUrl
        : FranchiseAppGlobal.deleteFileUrl
    }`;

    var observable = this.http.request("POST", url, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      body: {
        objectId: this.objectId,
        objectTypeId: this.objectTypeId,
        attachmentTypeId: this.attachmentTypeId,
      },
    });

    //var observable = this.http.delete(url, options)

    //this.showLoader()
    observable.subscribe(
      (res) =>
        this.deleteFileSuccess(
          this.objectId,
          this.objectTypeId,
          this.attachmentTypeId,
          res
        ),
      (res) => this.deleteFileError(res)
    );
    // this.fileUpload.nativeElement.value = ''
  }

  deleteFileSuccess(
    objectId: any,
    objectTypeId: any,
    attachementTypeId: any,
    res: any
  ) {
    //this.hideLoader()
    //this.getAttachments()

    let message = "تم حذف الملف بنجاح";
    this.deleteSuccessEvent(objectId, objectTypeId, attachementTypeId, message);
  }

  deleteFileError(res: any) {
    //this.hideLoader()

    let message = "حدث خطأ، يرجى المحاولة مرة أخرى";

    this.operaitonResult = {
      ID: ErrorCode.FailedToDeleteFile,
      Message: message,
    };

    this.errorEvent(this.operaitonResult);
    this.errorEvent(res);
  }

  showFile(publicId: any) {
    let url = this.displayUploadedFileUrl + publicId;
    this.http.get(url, { responseType: "blob" }).subscribe(
      (blob) => {
        let fileName = this.files.find((f) => f.publicId == publicId)?.fileName;
        saveAs(
          blob,
          fileName /*, { type: 'text/plain;charset=windows-1252' }*/
        );
      },
      (error) => {}
    );
    //window.open(url, '_blank')
  }

  preview(publicId: any) {
    let url = this.previewFileUrl + publicId;
    return this.http.get(url);
  }

  clearValidations() {
    this.isValidFileExtension = true;
    this.isValidFileSize = true;
    this.isValidFileName = true;
    this.isHarmFulExtension = false;
  }

  ValidateFileExtension() {
    return this.isValidFileExtension;
  }

  ValidateisValidFileSize() {
    return this.isValidFileSize;
  }

  ValidateisValidFileName() {
    return this.isValidFileName;
  }
  ValidateisHarmfulExtension() {
    return this.isHarmFulExtension;
  }

  ValidateisRequired() {
    return this.isRequired && this.formGroup.controls["fileUpload"].touched;
  }
  getFileName(fullPath: any): string {
    if (this.isValidFileName) {
      var startIndex =
        fullPath.indexOf("\\") >= 0
          ? fullPath.lastIndexOf("\\")
          : fullPath.lastIndexOf("/");
      var filename = fullPath.substring(startIndex);
      if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
        filename = filename.substring(1);
      }

      return filename;
    } else {
      return "اختيار ملف";
    }
  }
}
